import { makeStyles } from "@material-ui/core/styles";
import { get } from "../../../utils";
export const useStyles = makeStyles((theme) => ({
    pageMaxWidth: (props) => ({
        width: props.maxWidth
    }),
    alignRight: {
        padding: theme.spacing(2),
        float: "right",
        width: "fit-content"
    },
    background: (props) => ({
        backgroundColor: theme.palette?.[props.backgroundColor ?? ""]?.main ??
            get(theme.palette, props.backgroundColor) ??
            props.backgroundColor,
        borderRadius: 20
    })
}), { name: "DployFormFullWidth" });
export const actionsTheme = (theme) => ({
    ...theme,
    overrides: {
        ...theme.overrides,
        DployFormControl: {
            marginNormal: {
                marginTop: 0,
                marginBottom: 0
            }
        }
    }
});
// export const mainTheme = (theme: Theme): Theme => ({
// 	...theme,
// 	overrides: {
// 		...theme.overrides,
// 		DployFormSection: {
// 			header: {
// 				marginBottom: theme.spacing(1)
// 			}
// 		}
// 	} as any
// });
//# sourceMappingURL=styles.js.map